import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import get from "lodash/get";
import { Link } from "@quintype/components";

import { getCollection } from "../../../helper/api";
import StoryCard6 from "../../../molecules/story-card6";

import "./latest-news.m.css";
import Arrow from "../../../atoms/other-icons/Arrow";

const LatestNews = ({ showDualColumnWidget = true, showSingleColumnWidget = true }) => {
  const storyReducer = useSelector((state) => get(state, ["storyReducer"], []));
  const makeSecondaryApiCalls = storyReducer.makeSecondaryApiCalls;
  const delay = storyReducer.delay;

  const dispatch = useDispatch();
  const [isVisible, setIsVisible] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [moreStories, setMoreStories] = useState([]);
  const [recentStories, setRecentStories] = useState([]);
  const [dhPicks, setDhPicks] = useState([]);

  const fetchDataRecentNews = () => {
    try {
      if (!recentStories.length)
        getCollection("latest-news", 0, 5).then((stories) => {
          setRecentStories(stories);
          // dispatch(setLatestTenStoriesAction(stories));
        });
    } catch (error) {
      console.log(error);
    }
  };

  const fetchMoreNewsData = () => {
    try {
      if (!moreStories.length) getCollection("most-read", 0, 5).then((stories) => setMoreStories(stories));
    } catch (error) {
      console.log(error);
    }
  };

  const fetchDataDhPicks = () => {
    try {
      if (!dhPicks.length) getCollection("dh-picks", 0, 5).then((stories) => setDhPicks(stories));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (makeSecondaryApiCalls) {
      setTimeout(() => {
        fetchDataDhPicks();
        fetchMoreNewsData();
        fetchDataRecentNews();
      }, delay);
      setTimeout(() => setIsVisible(true), delay + 500);
    }
  }, [makeSecondaryApiCalls]);

  const handleTabSwitch = (tab) => () => setActiveTab(tab);

  const stories = activeTab === 0 ? moreStories : recentStories;
  return isVisible ? (
    <div styleName="wrapper">
      {showDualColumnWidget && (
        <div styleName="related-collection">
          <div styleName="title-wrapper">
            <div styleName={`title ${activeTab === 0 ? "active" : ""} `} onClick={handleTabSwitch(0)}>
              Most Read
            </div>
            <div styleName={`title ${activeTab === 1 ? "active" : ""} `} onClick={handleTabSwitch(1)}>
              Latest News
            </div>
          </div>
          <div styleName="stories">
            {stories.slice(0, 5).map((item, index) => (
              <StoryCard6 story={item} key={index} headerType={10} widths={[160]} />
            ))}
          </div>
        </div>
      )}
      {showSingleColumnWidget && (
        <div styleName="most-trending-wrapper">
          <div styleName="header-wrapper">
            <span styleName="title">DH PICKS</span>
            <Link styleName="see-more-stories" href={"/dh-picks"}>
              <Arrow height="24px" width="24px" color="black" />
            </Link>
          </div>
          <div styleName="stories">
            {dhPicks.slice(0, 4).map((item, index) => (
              <StoryCard6 story={item} key={index} headerType={10} widths={[160]} />
            ))}
          </div>
        </div>
      )}
    </div>
  ) : null;
};

export default LatestNews;
